<template>
    <div class="dialog-wrapper" :class="[dialogData.type && 'dialog-' + dialogData.type + '-wrapper']">
        <div class="dialog-inner">
            <div class="dialog-content">
                <div class="dialog-content-main">
                    <p v-html="dialogData.text" v-if="dialogData.text"></p>
                    <p class="sub-text" v-html="dialogData.subText" v-if="dialogData.subText"></p>
                    <div class="dialog-btns" v-if="dialogData.btns">
                        <div class="dialog-btn" :class="[btn.className]" @click="btnClick(btn)" v-for="btn in dialogData.btns"><span>{{btn.text}}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { mapState, mapMutations } from 'vuex'

import Moment from 'moment'
import Config from '@/utils/config'

import COVERAPP from '@/utils/COVERAPP'

@Options ({
    computed: {
        ...mapState(['userInfo', 'dialogData', 'activityData'])
    },
    methods: {
        ...mapMutations(['SET_DIALOGDATA', 'SET_USERINFO']),
        btnClick (btn: any) {
            if (btn.className === 'wxAuthorize-btn') {
                this.wxAuthorize()
                this.$common.track('click', '绑定微信')
            } else if (btn.className === 'download-btn') {
                this.downloadApp()
                this.$common.track('click', '下载app')
            } else if (btn.className === 'update-btn') {
                this.update()
                this.$common.track('click', '升级app')
            } else if (btn.className === 'login-btn') {
                this.login(btn)
                this.$common.track('click', '登录')
            } else if(btn.className === 'bindmobile-btn') {
                this.bindMobile(btn)
                this.$common.track('click', '绑定手机号')
            } else {
                this.SET_DIALOGDATA(null)
            }
        },
        wxAuthorize() {
            let _this = this
            COVERAPP.Method.wxAuthorize({
                callback(res: any) {
                    let data = typeof res == 'string'.toLowerCase() ? res : JSON.stringify(res)
                    if (JSON.parse(data).status == 1) {
                        const openid = JSON.parse(data).openid
                        let verifyOpenid = `${_this.userInfo.user_id.toString(36)}_${openid}_${(+Moment().format("YYYYMMDD")).toString(36)}`
                        let userInfo = JSON.parse(JSON.stringify(_this.userInfo))
                        userInfo.openid = openid
                        _this.SET_USERINFO(userInfo)
                        _this.bindWeixin(verifyOpenid)
                        _this.SET_DIALOGDATA(null)
                    }
                }
            })
        },
        bindWeixin (openid: string) {
            this.$request('/user/weixin/bind', {
                openid: openid,
                userinfo: this.userInfo
            }, 'put').then(() => {
                this.$common.toast('绑定微信成功')
            }).catch((res: any) => {
                if (res.errno == 1251) {
                    this.SET_DIALOGDATA({
                        text: '亲，您的微信号已授权，不能重复授权哦！',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                } else {
                    this.$common.toast('绑定微信失败')
                }
            })
        },
        downloadApp () {
            this.$common.downloadApp(this.activityData.openApp ? this.activityData.openApp.news_id : '', this.activityData.openApp && this.activityData.openApp.flag)
        },
        // 版本升级
        update () {
            if (COVERAPP.Attribute.isIOS()) {
                window.location.href = 'https://itunes.apple.com/cn/app/id1028293650'
            } else if (COVERAPP.Attribute.isAndroid()) {
                this.$common.loadjs(Config.DOWNLOAD_ADDRESS).then(()=> {
                    window.location.href = window.download_url
                })                
            }
        },
        // 登录
        login (btn: any) {
            const _this = this
            COVERAPP.Method.OpenLogin({
                callback (ret: any) {
                    let userinfo = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
                    if (!_this.$common.isEmpty(userinfo.token)) {
                        _this.$common.getUser((res: any) => {
                            _this.SET_USERINFO(res)
                            if (btn.callback) {
                                btn.callback()
                            }
                            _this.SET_DIALOGDATA(null)
                        })       																													
                    }
                }
            })
        },
        bindMobile (btn: any) {
            const _this = this
            COVERAPP.Method.bindMobile({
                callback(res: any) {
                    const result = typeof res != 'string' ? JSON.stringify(res) : res
                    if (result.indexOf('success') > -1) {
                        _this.$common.getUser((res: any) => {
                            _this.SET_USERINFO(res)
                            if (btn.callback) {
                                btn.callback()
                            }
                            _this.SET_DIALOGDATA(null)
                        })
                    }                    
                }
            })
        },
    }
})
export default class Dialog extends Vue {}
</script>

<style lang="scss">
.dialog-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}
.dialog-inner {
    width: 71.2963vw;
    position: absolute;
    right: 2.03704vw;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .dialog-content {
        min-height: 35vw;
        padding: 6vw;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 4vw;
        background-color: rgba(0,0,0,.7);
        position: relative;
        z-index: 1;
        box-sizing: border-box;
        animation: bounceIn 1s forwards;
    }
    .dialog-content-main {
        width: 100%;
        position: relative;
        z-index: 1;
    }
    p {
        font-size: 3.5vw;
        color: #fff;      
        line-height: 1.5;
        display: flex;
        align-items: center;
        text-align: justify;
        justify-content: center;
    }
    .dialog-btns {
        display: flex;
        justify-content: center;
        margin-top: 4vw;
        .dialog-btn {
            min-width: 18vw;
            height: 6vw;
            display: inline-flex;
            justify-content: center;
            background-color: #fff;
            border-radius: 3vw;
            align-items: center;
            position: relative;
            cursor: pointer;
            margin: 0 4vw;
            box-sizing: border-box;
            padding: 0 3vw;
            span {
                font-size: 3vw;
                color: #333;
                line-height: normal;
            }
            &.cancel-btn {
                background-color: rgba($color: #fff, $alpha: .74);
            }
        }
    }
}

@keyframes bounceIn {
    from,
    20%,
    40%,
    60%,
    80%,
    to {
        animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
        opacity: 0;
        transform: scale3d(0.3, 0.3, 0.3);
    }

    20% {
        transform: scale3d(1.1, 1.1, 1.1);
    }

    40% {
        transform: scale3d(0.9, 0.9, 0.9);
    }

    60% {
        opacity: 1;
        transform: scale3d(1.03, 1.03, 1.03);
    }

    80% {
        transform: scale3d(0.97, 0.97, 0.97);
    }

    to {
        opacity: 1;
        transform: scale3d(1, 1, 1);
    }
}

</style>
